import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { ConfirmationdialogService } from "../../utility/shared/confirmationdialog.service";
import { Toastpayload } from "../../utility/shared/toastpayload";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DaycloseserviceService } from '../shared/daycloseservice.service';
import { OpbalanceserviceService } from "../shared/opbalanceservice.service";
import { Role } from "./../../helpers/role";

@Component({
  selector: 'app-dayclose',
  templateUrl: './dayclose.component.html',
  styleUrls: ['./dayclose.component.css']
})

export class DaycloseComponent implements OnInit {

  toast: Toastpayload;
  DayCloseForm: FormGroup;
  BranchList = [];
  readonlyTextBox: boolean = true;

  constructor(private formBuilder: FormBuilder, private commonmastersService: CommonmastersService,
    private ngxLoader: NgxUiLoaderService,
    private confirmationdialogService: ConfirmationdialogService,
    private daycloseserviceService: DaycloseserviceService,
    private opbalanceserviceService: OpbalanceserviceService,
  ) { }

  ngOnInit() {

    this.readonlyTextBox = false;
    this.DayCloseForm = this.formBuilder.group({
      frmId: [0],
      frmTransactionNo: [0],
      frmBranchList: new FormControl({ value: JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"], disabled: true }),
      frmActive: [true],
      frmFromDate: new Date().toISOString().substring(0, 10),
      frmToDate: new Date().toISOString().substring(0, 10),
      frmIsDayClose: [1],
      frmFlag: [2], // for update.
    });

    this.GetAutogeneratedNumber()
    this.GetBranchList()

    if (JSON.parse(localStorage.getItem("EmployeeData"))["RoleId"] === Role.Admin) {
      const BranchlistCtrl = this.DayCloseForm.get('frmBranchList');
      BranchlistCtrl.enable();
    }
  }

  GetAutogeneratedNumber(): any {
    const TransactionNo = this.commonmastersService.FetchAutogeneratedNumber()
      .toPromise()
      .then(res => {

        this.DayCloseForm.patchValue({ frmTransactionNo: res[0].AutoGeneratedId });
        return Promise.resolve(res[0].AutoGeneratedId);
      })
      .catch(err => { console.log(err) });
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      return this.BranchList = data;
    })
  }

  onSubmit() {

    this.toast = {
      message: "No Message Now!",
      title: 'Loan Collection.!',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    // showing Loader 
    this.ngxLoader.start();

    //conformation dialog box
    let title: string = "Confirmation";
    let message: string = "The branch wise day close. Do you want to continue?";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed => {
        if (confirmed == true) {

          this.daycloseserviceService.ledgerentries.TransactionId = this.DayCloseForm.value.frmTransactionNo;
          this.daycloseserviceService.ledgerentries.CostCentreId = this.DayCloseForm.value.frmBranchList;
          this.daycloseserviceService.ledgerentries.ToDate = new Date(this.DayCloseForm.value.frmToDate);
          this.daycloseserviceService.ledgerentries.FromDate = new Date(this.DayCloseForm.value.frmFromDate);
          this.daycloseserviceService.ledgerentries.IsDayClose = this.DayCloseForm.value.frmIsDayClose;

          this.daycloseserviceService.IUDDayClose(this.daycloseserviceService.ledgerentries)
            .toPromise()
            .then(data => {
              console.log("Output recived")
            })
            .catch(err => { console.log(err) });
        }
      })

    // Closing Loader
    this.ngxLoader.stop();
  }

}
